/**
 *
 */

import React, { useState, useEffect } from "react";
import Header from "./local-component/Header";
import {
  FilterFilledWhite,
  LocationPinFilledGrey,
} from "../../setup/constants/images";

/* Import configuration starts */

import { MdOutlineAddToQueue } from "react-icons/md";
import { FaAngleRight, FaAngleLeft } from "react-icons/fa";

/* Import configuration ends */

/* Import redux slices component starts */
/* Import redux slices component ends */

/* Import react bootstrap component starts */
/* Import react bootstrap component ends */

/* Import image and SVG starts */
/* Import image and SVG ends */

/* Import local pages and component starts */
/* Import local pages and component ends */

import "./style.scss";
import Searchbar from "../../components/ui/other/Searchbar/Searchbar";
import IconButton from "../../components/ui/button/IconButton/IconButton";
import { Link } from "react-router-dom";
import moment from "moment";
import FullCalenderPage from "../../components/module/RnD/FullCalenderPage/FullCalenderPage";

/* Component starts */
const StaffScheduling = (props) => {
  /* Props destructuring starts */
  const {} = props;
  /* Props destructuring ends */

  /* Component states and useRef declaration starts */
  const [test, setTest] = useState(moment());
  const [month, setMonth] = useState(moment().format("MMM YYYY"));
  const [value, setValue] = useState("day");

  let runFilter;
  /* Component states and useRef declaration ends */

  /* Other hooks declaration starts */
  /* Other hooks declaration ends */

  /* Component variable declaration / object destructure starts */

  const profilesList = [
    {
      id: "1",
      name: "Johnny",
      url: "data:image/jpeg;base64,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",
    },
    {
      id: "2",
      name: "Cena",
      url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTVJ8SffqelXh1SfBJ4O8jIiDYHqtf4ph6LrK94Ze2L7fSdmvEzpyLPFdHx_xyMoDMRgN4&usqp=CAU",
    },
    {
      id: "3",
      name: "Lana",
      url: "https://ffarm.upertis.ac.id/wp-content/uploads/2017/12/instructor4.jpg",
    },
  ];

  /* Component variable declaration / object destructure ends */

  /* Component function definition starts */

  const handlePrevDate = (value) => {
    console.log(value, "[VAL]");
    if (value === "day") {
      setTest((prev) => {
        const t = moment(new Date(prev));
        return t.subtract(1, "days");
      });
    } else if (value === "month") {
      setTest((prev) => {
        const t = moment(new Date(prev));
        return t.subtract(1, "month");
      });
    } else {
      console.log("TETS");
    }
    console.log(test, "DECR");
  };

  const handleNextDate = (value) => {
    if (value === "day") {
      setTest((prev) => {
        const t = moment(new Date(prev));
        return t.add(1, "days");
      });
    } else if (value === "month") {
      setTest((prev) => {
        const t = moment(new Date(prev));
        return t.add(1, "month");
      });
    } else {
      setTest((prev) => {
        const t = moment(new Date(prev));

        console.log(t.add(1, "days").format("ddd,DD MMM"), "-=-=-");
        console.log(t.add(6, "days").format("ddd,DD MMM"), "[][]");

        // console.log("prev start", t.weekday(-7).format("ddd,DD MMM"));
        // console.log("prev end", t.weekday(-1).format("ddd,DD MMM"));

        // console.log("current start", t.weekday(0).format("ddd,DD MMM"));
        // console.log("current end", t.weekday(6).format("ddd,DD MMM"));

        // console.log("next start", t.weekday(7).format("ddd,DD MMM"));
        // console.log("next end", t.weekday(13).format("ddd,DD MMM"));

        // console.log(t.add(7, "week").format('ddd,DD MMM'), "[][]");

        // console.log(t.subtract(7, "week").format('ddd,DD MMM'), "[0][0]");
        // return t.add(1, 'week');

        return `${t.add(1, "days").format("ddd,DD MMM")} - ${t
          .add(6, "days")
          .format("ddd,DD MMM")}`;
      });
    }
  };

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  /* Component function definition ends */

  /* Component useEffect starts */
  /* Component useEffect ends */

  /* ************* Component rendering. JSX code ************* */
  return (
    <div className="staff-scheduling-wrapper">
      <h4 className="font_xxl fw_6 text-center mb-2">Staff Scheduling</h4>
      {/* <div className="header">
        <Header />
      </div> */}
      <div className="heading-details bg_grey mb-3">
        <div className="location-wrapper">
          <p className="font_l fw_6">Blond Lodge</p>
          <span className="font_s font_grey fw_4">
            <img src={LocationPinFilledGrey} alt="location-pin" />
            766 Roloh Road, Painesville, OH 04777
          </span>
        </div>

        <div className="date-wrapper">
          {value === "day" ? (
            <div className="bg_darkgrey date">
              <div className="icon-wrapper">
                <FaAngleLeft
                  size={25}
                  className="px-2"
                  onClick={() => handlePrevDate(value)}
                />
              </div>
              <div>
                {/* <span className="font_xs font_grey fw_4">Wed,23 October</span> */}
                <span className="font_xs font_grey fw_4">
                  {value === "day" && test.format("ddd,DD MMMM")}
                </span>
              </div>
              <div className="icon-wrapper">
                <FaAngleRight
                  size={25}
                  className="px-2"
                  onClick={() => handleNextDate(value)}
                />
              </div>
            </div>
          ) : value === "month" ? (
            <div className="bg_darkgrey date">
              <div className="icon-wrapper">
                <FaAngleLeft
                  size={25}
                  className="px-2"
                  onClick={() => handlePrevDate(value)}
                />
              </div>
              <div>
                {/* <span className="font_xs font_grey fw_4">Wed,23 October</span> */}
                <span className="font_xs font_grey fw_4">
                  {value === "month" && test.format("MMM YYYY")}
                </span>
              </div>
              <div className="icon-wrapper">
                <FaAngleRight
                  size={25}
                  className="px-2"
                  onClick={() => handleNextDate(value)}
                />
              </div>
            </div>
          ) : (
            <div className="bg_darkgrey date">
              <div className="icon-wrapper">
                <FaAngleLeft
                  size={25}
                  className="px-2"
                  onClick={() => handlePrevDate(value)}
                />
              </div>
              <div>
                {/* <span className="font_xs font_grey fw_4">Wed,23 October</span> */}
                <span className="font_xs font_grey fw_4">
                  {value === "week" &&
                    `${test.startOf("isoWeek").format("ddd,DD MMM")} 
                    - 
                    ${test.endOf("isoWeek").format("ddd,DD MMM")}`}
                </span>
              </div>
              <div className="icon-wrapper">
                <FaAngleRight
                  size={25}
                  className="px-2"
                  onClick={() => handleNextDate(value)}
                />
              </div>
            </div>
          )}
        </div>

        <div className="date-wrapper-view">
          <div className="bg_darkgrey date">
            <span className="font_xs font_grey fw_4">View: Employee | </span>
            <select className="drop-down" value={value} onChange={handleChange}>
              <option value="day">Day</option>
              <option value="week">Week</option>
              <option value="month">Month</option>
            </select>
          </div>
        </div>
      </div>

      <div className="schedule-wrapper">
        <div className="emp-details bg_grey">
          <div className="search-box">
            <div className="search">
              <Searchbar />
            </div>
            <IconButton className="icon">
              <img src={FilterFilledWhite} alt="filter-icon" />
            </IconButton>
          </div>

          <div className="profile-details-wrapper">
            <p className="font_xxs font_blue fw_4 text-decoration-underline">
              Company Guarda
            </p>
            {profilesList?.map((profile) => (
              <div className="profile" key={profile.id}>
                <div className="detail">
                  <img src={profile.url} />
                  <span className="font_m font_grey fw_4">{profile.name}</span>
                </div>
                <div className="dropdown">
                  <span className="font_xl font_blue fw_4 plus">+</span>
                  <div className="dropdown-content">
                    <Link
                      className="link-tag"
                      to="/property/staff-scheduling/create-schedule"
                    >
                      <MdOutlineAddToQueue size={20} color="#151517" />
                      <span className="font_xxs font_black fw_4 px-2">
                        Create Schedule
                      </span>
                    </Link>
                    <Link
                      className="link-tag"
                      to="/property/staff-scheduling/add-vacation"
                    >
                      <MdOutlineAddToQueue size={20} className="icon" />
                      <span className="font_xxs font_black fw_4 px-2">
                        Add Vacation
                      </span>
                    </Link>
                    <Link
                      className="link-tag"
                      to="/property/staff-scheduling/add-holidays"
                    >
                      <MdOutlineAddToQueue size={20} className="icon" />
                      <span className="font_xxs font_black fw_4 px-2">
                        Add Holidays
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            ))}

            <p className="font_xxs font_blue fw_4 text-decoration-underline">
              Company Tesla
            </p>
            {profilesList?.map((profile) => (
              <div className="profile" key={profile.id}>
                <div className="detail">
                  <img src={profile.url} />
                  <span className="font_m font_grey fw_4">{profile.name}</span>
                </div>
                <div className="dropdown">
                  <span className="font_xl font_blue fw_4 plus">+</span>
                  <div className="dropdown-content">
                    <Link
                      className="link-tag"
                      to="/property/staff-scheduling/create-schedule"
                    >
                      <MdOutlineAddToQueue size={20} color="#151517" />
                      <span className="font_xxs font_black fw_4 px-2">
                        Create Schedule
                      </span>
                    </Link>
                    <Link
                      className="link-tag"
                      to="/property/staff-scheduling/add-vacation"
                    >
                      <MdOutlineAddToQueue size={20} className="icon" />
                      <span className="font_xxs font_black fw_4 px-2">
                        Add Vacation
                      </span>
                    </Link>
                    <Link
                      className="link-tag"
                      to="/property/staff-scheduling/add-holidays"
                    >
                      <MdOutlineAddToQueue size={20} className="icon" />
                      <span className="font_xxs font_black fw_4 px-2">
                        Add Holidays
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="schedule-details">
          {/* {value === "month" && (
            <div className="dates-wrapper bg_grey">
              <div className="d-flex align-items-center justify-content-center">Jan</div>
              <div className="d-flex align-items-center justify-content-center">Jan</div>
              <div className="d-flex justify-content-center">Jan</div>
              <div className="d-flex justify-content-center">Jan</div>
              <div className="d-flex justify-content-center">Jan</div>
              <div className="d-flex justify-content-center">Jan</div>
              <div className="d-flex justify-content-center">Jan</div>
              <div className="d-flex justify-content-center">Jan</div>
              <div className="d-flex justify-content-center">Jan</div>
              <div className="d-flex justify-content-center">Jan</div>
              <div className="d-flex justify-content-center">Jan</div>
              <div className="d-flex justify-content-center">Jan</div>
            </div>
          )} */}

          {value === "month" ? (
            <FullCalenderPage type={value} />
          ) : value === "week" ? (
            <FullCalenderPage type={value} />
          ) : (
            <FullCalenderPage type={value} />
          )}

          <div className="values-wrapper">VALUES</div>
        </div>
      </div>
    </div>
  );
};
/* Component ends */

export default StaffScheduling;
